import './NowPlaying.css';

export default function NowPlaying() {
  return (
    <section className="now-playing">
      <h2 className="section-title">What am I up to?</h2>

      <div className="cards-grid">
        {/* Hollow Tunes Card */}
        <div className="card hollow-tunes">
          <div className="card-text">
            <h3>
              Hollow Tunes<br />
              <span className="frequency">104.6</span>
            </h3>
            <p>
              🌙✨ Curated soundscapes for quiet nights, creative focus, and dreamy escapes.

            </p>

            
            <a href="https://www.youtube.com/@HollowTunes" className="card-button"   target="_blank"   rel="noopener noreferrer" >Go to channel</a>
          </div>
          <div className="card-art" />
        </div>

        {/* Project Arcana Card */}
        <div className="card project-arcana">
          <div className="image-wrapper">
            <img
            />
          </div>

          <div className="card-text">
            <h3>✨ Project Arcana 🧙‍♂️
            <div className="tagline"></div>
            </h3>
            <p>
              A TTRTCG game idea.
            </p>
            <a href="#" className="card-button card-button-learn">Learn more</a>
          </div>
        </div>
      </div>
    </section>
  );
}
